module.exports = __webpack_public_path__ + "static/media/Bento.414797e8.jpeg";